module.exports = __webpack_public_path__ + "static/media/ic_user_settings.d1c0cf83.svg";